export default __webpack_public_path__ + "static/media/Group9173.d4ee60f2.svg";